export const POPOVER_DISPLAYED = 'cp.crmPopovers.displayed';
export const POPOVER_ACCEPTED = 'cp.crmPopovers.clickThrough';
export const POPOVER_INTERACTION = 'cp.crmPopovers.Interactions';
export const POPOVER_DISMISSED = 'cp.crmPopovers.dismiss-x';
export const POPOVER_ERROR = 'cp.crmPopovers.error';
export const POPOVER_TYPE_CAMPAIGN = 'PopOvercampaign';
